export { default as DisplaySettingsResolutionPanel } from './DisplaySettingsResolutionPanel';
